/* Nivahra — fiche « bracelet photo » : galerie, modèle + couleur, envoi et recadrage de la photo, ajout au panier.
   La photo recadrée part avec le formulaire (propriété « Photo »), envoi classique vers /cart/add. */
(function () {
  if (!window.customElements || customElements.get('nv-bracelet')) return;

  function money(cents, format) {
    var fmt = String(format || ('{' + '{amount_with_comma_separator}' + '} €')).replace(/<[^>]*>/g, '');
    var v = Number(cents) / 100;
    function d(n, dec, th, ds) { var p = n.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(ds); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return d(v, 0, ',', '.');
        case 'amount_with_comma_separator': return d(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return d(v, 0, '.', ',');
        case 'amount_with_space_separator': return d(v, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return d(v, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return d(v, 2, "'", '.');
        default: return d(v, 2, ',', '.');
      }
    });
  }

  class NvBracelet extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      var data = this.querySelector('script[data-nv-data]');
      if (!data) return;
      try { this.d = JSON.parse(data.textContent); } catch (e) { return; }
      this._ready = true;
      this.idInput = this.querySelector('[data-variant-id]');
      var self = this, vs = this.d.variants;
      var v0 = vs.filter(function (v) { return String(v.id) === String(self.idInput && self.idInput.value); })[0] || vs.filter(function (v) { return v.available; })[0] || vs[0];
      this.state = { model: v0 ? v0.o[0] : null, color: v0 && v0.o.length > 1 ? v0.o[1] : null };
      this.bindGallery();
      this.bindOptions();
      this.bindUpload();
      this.bindForm();
      this.setEta();
      this.update(false);
      if (v0 && v0.media > 0) this.go(v0.media);
    }

    match(model, color) {
      var vs = this.d.variants.filter(function (v) { return v.o[0] === model && (color === null || v.o[1] === color); });
      return vs.filter(function (v) { return v.available; })[0] || vs[0] || null;
    }
    colorsFor(model) { return this.d.variants.filter(function (v) { return v.o[0] === model; }).map(function (v) { return v.o[1]; }); }
    money(c) { return money(c, this.d.moneyFormat); }
    t(k) { return (this.d.i18n && this.d.i18n[k]) || ''; }

    /* ---------- Galerie ---------- */
    bindGallery() {
      var self = this;
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
      this.thumbs.forEach(function (t, i) { t.addEventListener('click', function () { self.go(i); }); });
      var prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.cur - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.cur + 1); });
      var stage = this.querySelector('[data-stage]');
      if (stage) {
        stage.classList.add('is-ready');
        var x0 = null;
        stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) self.go(self.cur + (dx < 0 ? 1 : -1)); x0 = null; });
      }
      if (this.slides.length < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; }
      this.go(0);
    }
    go(i) {
      var n = this.slides.length; if (!n) return;
      this.cur = ((i % n) + n) % n;
      var self = this;
      this.slides.forEach(function (s, k) {
        var on = k === self.cur;
        s.classList.toggle('is-active', on);
        var v = s.querySelector('video');
        if (v) { if (on) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }
      });
      this.thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === self.cur); });
    }

    /* ---------- Modèle + couleur ---------- */
    bindOptions() {
      var self = this;
      this.querySelectorAll('[data-model]').forEach(function (b) {
        b.addEventListener('click', function () {
          var m = b.getAttribute('data-model'), cols = self.colorsFor(m);
          self.state.model = m;
          if (self.state.color !== null && cols.indexOf(self.state.color) < 0) {
            var av = self.d.variants.filter(function (v) { return v.o[0] === m && v.available; })[0];
            self.state.color = av ? av.o[1] : cols[0];
          }
          self.update(true);
        });
      });
      this.querySelectorAll('[data-color-swatch]').forEach(function (b) {
        b.addEventListener('click', function () { self.state.color = b.getAttribute('data-color-swatch'); self.update(true); });
      });
    }
    update(fromUser) {
      var self = this, st = this.state, v = this.match(st.model, st.color);
      this.variant = v;
      if (v && this.idInput) this.idInput.value = v.id;
      var cta = this.querySelector('[data-cta]'), label = this.querySelector('[data-cta-label]');
      if (cta && !this._submitting) {
        var ok = !!(v && v.available);
        cta.disabled = !ok;
        if (label) label.textContent = ok ? this.t('cta') : this.t('soldOut');
      }
      this.querySelectorAll('[data-cta-price]').forEach(function (e) { if (v) e.textContent = self.money(v.price); });
      this.querySelectorAll('[data-price-compare]').forEach(function (c) {
        if (v && v.compare > v.price) { c.hidden = false; c.textContent = self.money(v.compare); } else { c.hidden = true; }
      });
      this.querySelectorAll('[data-model]').forEach(function (b) {
        var on = b.getAttribute('data-model') === st.model;
        b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var cols = this.colorsFor(st.model);
      this.querySelectorAll('[data-color-swatch]').forEach(function (b) {
        var c = b.getAttribute('data-color-swatch'), on = c === st.color;
        b.hidden = cols.indexOf(c) < 0;
        b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var cn = this.querySelector('[data-color-name]'); if (cn && st.color) cn.textContent = st.color;
      if (fromUser && v) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e) {}
        if (v.media >= 0) this.go(v.media);
      }
    }

    /* ---------- Date de livraison estimée ---------- */
    setEta() {
      var eta = this.querySelector('[data-eta]');
      if (!eta || !this.d.deliver) return;
      var lang = document.documentElement.lang || 'fr', dot = /^de/i.test(lang) ? '.' : '';
      var fmt = function (d) { return d.toLocaleDateString(lang, { day: 'numeric', month: 'short' }); };
      var add = function (n) { var r = new Date(); r.setHours(0, 0, 0, 0); r.setDate(r.getDate() + n); return r; };
      var a = add(this.d.deliver[0]), b = add(Math.max(this.d.deliver[0], this.d.deliver[1]));
      eta.textContent = a.getMonth() === b.getMonth() ? a.getDate() + dot + '–' + fmt(b) : fmt(a) + ' – ' + fmt(b);
    }

    /* ---------- Photo : envoi + recadrage ---------- */
    bindUpload() {
      var self = this, box = this.querySelector('[data-up]');
      if (!box) return;
      var u = this.up = {
        box: box, input: box.querySelector('[data-up-input]'), zone: box.querySelector('[data-up-zone]'),
        crop: box.querySelector('[data-crop]'), frame: box.querySelector('[data-crop-frame]'), img: box.querySelector('[data-crop-img]'),
        zoom: box.querySelector('[data-crop-zoom]'), final: box.querySelector('[data-up-final]'), note: box.querySelector('[data-up-note]'),
        laterProp: box.querySelector('[data-later-prop]'), later: box.querySelector('[data-later]'), change: box.querySelector('[data-up-change]')
      };
      u.input.addEventListener('change', function () { if (u.input.files && u.input.files[0]) self.loadFile(u.input.files[0]); });
      ['dragenter', 'dragover'].forEach(function (ev) { u.zone.addEventListener(ev, function (e) { e.preventDefault(); u.zone.classList.add('is-drag'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { u.zone.addEventListener(ev, function (e) { e.preventDefault(); u.zone.classList.remove('is-drag'); }); });
      u.zone.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; if (f) self.loadFile(f); });
      if (u.change) u.change.addEventListener('click', function () { u.input.value = ''; u.input.click(); });
      u.zoom.addEventListener('input', function () { self.setZoom(parseFloat(u.zoom.value) || 1); });
      var start = null;
      u.frame.addEventListener('pointerdown', function (e) {
        if (!self.cs) return;
        start = { x: e.clientX, y: e.clientY, ox: self.cs.x, oy: self.cs.y };
        try { u.frame.setPointerCapture(e.pointerId); } catch (err) {}
        e.preventDefault();
      });
      u.frame.addEventListener('pointermove', function (e) {
        if (!start) return;
        self.cs.x = start.ox + e.clientX - start.x; self.cs.y = start.oy + e.clientY - start.y;
        self.renderCrop();
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { u.frame.addEventListener(ev, function () { start = null; }); });
      u.frame.addEventListener('wheel', function (e) {
        if (!self.cs) return;
        e.preventDefault();
        var z = Math.min(3, Math.max(1, self.cs.z - e.deltaY * 0.002));
        u.zoom.value = z; self.setZoom(z);
      }, { passive: false });
      if (u.later) u.later.addEventListener('change', function () { self.setLater(u.later.checked); });
      var rt = null;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (self.cs) self.initCrop(true); }, 150); });
    }
    loadFile(f) {
      var self = this, u = this.up;
      if (!/^image\//i.test(f.type || '') && !/\.(jpe?g|png|webp|gif|heic|heif)$/i.test(f.name || '')) { this.toast(this.t('notImage')); return; }
      if (f.size > (this.d.maxMb || 20) * 1048576) { this.toast(this.t('tooBig')); return; }
      this.file = f; this.cropOk = false; this.cs = null;
      if (u.later && u.later.checked) { u.later.checked = false; this.setLater(false); }
      u.box.classList.remove('is-error');
      if (this._url) URL.revokeObjectURL(this._url);
      this._url = URL.createObjectURL(f);
      u.img.onload = function () {
        self.cropOk = true;
        u.zone.hidden = true; u.crop.hidden = false; if (u.note) u.note.hidden = true;
        self.initCrop(false);
      };
      u.img.onerror = function () {
        /* Format non lisible par le navigateur (ex. HEIC) : on envoie la photo d'origine, sans recadrage. */
        self.cropOk = false;
        u.crop.hidden = true; u.zone.hidden = false;
        if (u.note) { u.note.hidden = false; u.note.textContent = '✔ ' + (f.name || 'photo'); }
      };
      u.img.src = this._url;
    }
    initCrop(keep) {
      var u = this.up, F = u.frame.clientWidth, w = u.img.naturalWidth, h = u.img.naturalHeight;
      if (!F || !w || !h) return;
      var z = keep && this.cs ? this.cs.z : 1, base = Math.max(F / w, F / h), s = base * z;
      this.cs = { F: F, w: w, h: h, base: base, z: z, x: (F - w * s) / 2, y: (F - h * s) / 2 };
      u.zoom.value = z;
      this.renderCrop();
    }
    setZoom(z) {
      var c = this.cs; if (!c) return;
      var s0 = c.base * c.z, s1 = c.base * z, cx = (c.F / 2 - c.x) / s0, cy = (c.F / 2 - c.y) / s0;
      c.z = z; c.x = c.F / 2 - cx * s1; c.y = c.F / 2 - cy * s1;
      this.renderCrop();
    }
    renderCrop() {
      var c = this.cs; if (!c) return;
      var s = c.base * c.z, W = c.w * s, H = c.h * s;
      c.x = Math.min(0, Math.max(c.F - W, c.x)); c.y = Math.min(0, Math.max(c.F - H, c.y));
      var i = this.up.img;
      i.style.width = W + 'px'; i.style.height = H + 'px';
      i.style.transform = 'translate(' + c.x + 'px,' + c.y + 'px)';
    }
    exportCrop() {
      var self = this, c = this.cs, img = this.up && this.up.img;
      return new Promise(function (res) {
        try {
          if (!self.cropOk || !c || !img) return res(null);
          var s = c.base * c.z, sx = -c.x / s, sy = -c.y / s, sw = c.F / s;
          var out = Math.round(Math.min(1200, Math.max(600, sw)));
          var cv = document.createElement('canvas'); cv.width = out; cv.height = out;
          var g = cv.getContext('2d'); g.fillStyle = '#fff'; g.fillRect(0, 0, out, out);
          g.drawImage(img, sx, sy, sw, sw, 0, 0, out, out);
          if (!cv.toBlob) return res(null);
          cv.toBlob(function (b) {
            if (!b) return res(null);
            try { res(new File([b], 'photo-bracelet.jpg', { type: 'image/jpeg' })); } catch (e) { res(null); }
          }, 'image/jpeg', 0.92);
        } catch (e) { res(null); }
      });
    }
    setLater(on) {
      var u = this.up; if (!u) return;
      u.box.classList.toggle('is-later', on);
      if (u.laterProp) u.laterProp.disabled = !on;
      if (u.final) u.final.disabled = on;
      if (on) u.box.classList.remove('is-error');
    }

    /* ---------- Ajout au panier ---------- */
    bindForm() {
      var self = this, form = this.querySelector('form.nv-form');
      if (!form) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (self._submitting) return;
        var u = self.up, later = !!(u && u.later && u.later.checked);
        if (u && !later && !self.file) {
          u.box.classList.add('is-error');
          self.toast(self.t('photoError'));
          u.box.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        var cta = self.querySelector('[data-cta]'), label = self.querySelector('[data-cta-label]');
        self._submitting = true;
        if (cta) { cta.disabled = true; cta.setAttribute('aria-busy', 'true'); }
        if (label && u && !later) label.textContent = self.t('sending');
        var send = function (file) {
          if (u && !later) {
            var f = file || self.file, ok = false;
            try { var dt = new DataTransfer(); dt.items.add(f); u.final.files = dt.files; ok = !!(u.final.files && u.final.files.length === 1); } catch (err) {}
            if (!ok) { u.final.disabled = true; u.input.setAttribute('name', u.final.getAttribute('name')); }
          }
          if (cta) cta.disabled = false;
          HTMLFormElement.prototype.submit.call(form);
        };
        if (u && !later) self.exportCrop().then(send); else send(null);
      });
      window.addEventListener('pageshow', function () {
        self._submitting = false;
        var cta = self.querySelector('[data-cta]'); if (cta) cta.removeAttribute('aria-busy');
        self.update(false);
      });
    }
    toast(msg) {
      var t = this.querySelector('[data-toast]'); if (!t || !msg) return;
      t.textContent = msg; t.classList.add('is-visible');
      clearTimeout(this._tt); var self = this;
      this._tt = setTimeout(function () { t.classList.remove('is-visible'); }, 3800);
    }
  }
  customElements.define('nv-bracelet', NvBracelet);
})();